import { Component } from '@angular/core';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../components/content/content.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-privacy-statement-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent
  ],
  templateUrl: './privacy-statement-page.component.html'
})
export class PrivacyStatementPageComponent {

}
